module.exports = __webpack_public_path__ + "static/paris-007-0ea4e2ab23bd32f4b5498c0903184c16.jpg";